import React from "react";
import { Container } from "react-bootstrap";
import BreadCrumb from "../src/components/Shared/BreadCrumb";
import server from "../src/api/server";
import { useIntl } from "react-intl";
import { NextSeo } from "next-seo";
const PrivacyPage = ({ privacyData, error, metaDataSections }) => {
  error && console.log(JSON.parse(error));
  const { locale, formatMessage } = useIntl();
  // console.log(privacyData[0]?.description[locale], "privacy");
  const privacyMeta = metaDataSections?.find(
    (item) => item?.slug === "privacy"
  );
  return (
    <>
      <NextSeo
        title={privacyMeta?.name[locale]}
        description={privacyMeta?.description[locale]}
        additionalMetaTags={[
          {
            name: "keywords",
            content: "",
          },
          {
            name: "description",
            content: "",
          },
        ]}
      />
      <div className="about-page">
        <BreadCrumb
          title={formatMessage({ id: "Privacy Policy" })}
          pageTitle={formatMessage({ id: "Privacy Policy" })}
        />
        <div className="about-page-body">
          <Container>
            <div
              className="terms-sec"
              style={{
                marginBlock: "60px",
                fontSize: "20px",
              }}
              dangerouslySetInnerHTML={{
                __html: privacyData[0]?.description[locale],
              }}
            ></div>
          </Container>
        </div>
      </div>
    </>
  );
};

export const getStaticProps = async (ctx) => {
  try {
    const privacyResponse = await server.get("/pages/privacy");
    const metaDataResponse = await server.get("/pages/metaData");
    return {
      revalidate: 1,
      props: {
        metaDataSections: metaDataResponse?.data?.data?.page?.sections,
        privacyData: privacyResponse.data.data.page.sections,
      },
    };
  } catch (error) {
    return {
      revalidate: 1,
      props: {
        error: JSON.stringify(error),
      },
    };
  }
};

export default PrivacyPage;
